import React from "react";

function PrevPageIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<rect width="32" height="32" fill="#fff" rx="16" />
			<path
				fill="#10324C"
				fillRule="evenodd"
				d="M19.09 10.41a.833.833 0 010 1.18L14.678 16l4.41 4.41a.833.833 0 11-1.178 1.18l-5-5a.833.833 0 010-1.18l5-5a.833.833 0 011.178 0z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

function NextPageIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<rect width="32" height="32" fill="#fff" rx="16" />
			<path
				fill="#10324C"
				fillRule="evenodd"
				d="M12.91 10.41a.833.833 0 011.18 0l5 5a.833.833 0 010 1.18l-5 5a.833.833 0 11-1.18-1.18L17.323 16l-4.411-4.41a.833.833 0 010-1.18z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

export { PrevPageIcon, NextPageIcon };
